<template lang="pug">
    .slide(:class="{ hover: mouseover }")
        section.left(:style="style")
            .image(ref="container")
                figure
                    router-link(
                        v-if="path"
                        :to="path"
                        @mouseover.native="hover"
                        @mouseleave.native="blur"
                    )
                        img.swiper-lazy(
                            lazy="loaded"
                            :data-src="image.src"
                            :title="slide.title || slide.sub_title"
                            :style="{ width: `${width}px`, height: `${height}px` }"
                        )
                        img.preview(
                            lazy="loading"
                            :src="image.loading"
                            :title="slide.title || slide.sub_title"
                            :style="{ width: `${width}px`, height: `${height}px` }"
                        )
                        // img(v-lazy="image" :title="slide.title || slide.sub_title")
                    a(
                        v-else-if="href"
                        :href="href"
                        :title="slide.title || slide.sub_title"
                        :target="target"
                        @mouseover="hover"
                        @mouseleave="blur"
                    )
                        img.swiper-lazy(
                            lazy="loaded"
                            :data-src="image.src"
                            :title="slide.title || slide.sub_title"
                            :style="{ width: `${width}px`, height: `${height}px` }"
                        )
                        img.preview(
                            lazy="loading"
                            :src="image.loading"
                            :title="slide.title || slide.sub_title"
                            :style="{ width: `${width}px`, height: `${height}px` }"
                        )
                        // img(v-lazy="image" :title="slide.title || slide.sub_title")
                    template(v-else)
                        img.swiper-lazy(
                            lazy="loaded"
                            :data-src="image.src"
                            :title="slide.title || slide.sub_title"
                            :style="{ width: `${width}px`, height: `${height}px` }"
                        )
                        img.preview(
                            lazy="loading"
                            :src="image.loading"
                            :title="slide.title || slide.sub_title"
                            :style="{ width: `${width}px`, height: `${height}px` }"
                        )
        section.right
            .content
                h2(v-if="slide.title") {{ slide.title }}
                h4(v-if="slide.sub_title") {{ slide.sub_title }}
                div(v-if="slide.text" v-html="slide.text")
                router-link.more-link(
                    v-if="path"
                    :to="path"
                )
                    | {{ linkText }}
                a.more-link(
                    v-else-if="href"
                    :href="href"
                    :title="slide.title || slide.sub_title"
                    :target="target"
                )
                    | {{ linkText }}

</template>

<script>

import _ from 'lodash'

export default {
    name: 'Slide',
    data() {
        return {
            maxWidth: undefined,
            delay: 0,
            mouseover: false,
        }
    },
    props: {
        slide: {
            type: Object,
            required: true,
        },
        // imageLoaded: {
        //     type: Boolean,
        //     default: false,
        // }
    },
    computed: {
        image() {
            const image = _.get(this.slide, 'images.0')
            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1.1111111111'
            const parameters = {
                ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h, fx, fy, fz } = parameters

            let width, height, aspectRatio

            width = image.width / fz
            height = image.height / fz
            aspectRatio = width / height

            height = Math.min(window.innerWidth >= 1088 ? 400 : 140, height)
            width = height * aspectRatio

            if (this.maxWidth < width) {
                height = this.maxWidth / aspectRatio
                height = Math.min(window.innerWidth >= 1088 ? 400 : 140, height)
                width = height * aspectRatio
            }

            if (w && h) {
                aspectRatio = w / h

                height = Math.min(window.innerWidth >= 1088 ? 400 : 140, image.height / fz)
                width = height * aspectRatio

                if (this.maxWidth < width) {
                    height = this.maxWidth / aspectRatio
                    height = Math.min(window.innerWidth >= 1088 ? 400 : 140, image.height / fz)
                    width = height * aspectRatio
                }

                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&h=${height}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
                width,
                height,
                aspectRatio,
            }
        },
        width() {
            if (this.image.width) return Math.min(this.maxWidth, this.image.width)
            else return undefined
        },
        height() {
            if (this.width && this.image.aspectRatio) return this.width / this.image.aspectRatio
            else return undefined
        },
        hyperlink() {
            return _.get(this.slide, 'hyperlink') || {}
        },
        href() {
            let href = false

            if (this.hyperlink.type !== 'internal' && _.get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href
                switch (this.hyperlink.type) {
                    case 'external':
                        if (! _.startsWith(link, 'https://') && ! _.startsWith(link, 'http://')) href = `https://${link}`
                        else href = link
                        break;

                    case 'mailto':
                        href = `mailto:${link}`
                        break;

                    case 'tel':
                        href = `tel:${link}`
                        break;
                }
            }

            return href
        },
        target() {
            return _.get(this.hyperlink, 'target') || '_self'
        },
        path() {
            if (this.hyperlink.type === 'internal' && _.get(this.hyperlink, 'menuItem.path')) return this.hyperlink.menuItem.path
            else return false
        },
        linkText() {
            return _.get(this.hyperlink, 'name') || 'mehr...'
        },
        style() {
            let style = {}

            if (this.slide.color) {
                style.background = this.slide.color
            }

            return style
        },
    },
    methods: {
        hover() {
            this.$emit('focus', this.item)
            this.mouseover = true
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item)
                this.mouseover = false
            }, this.delay);
        },
    },
    mounted() {
        const calculateMaxWidth = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                this.maxWidth = this.$refs.container.clientWidth
                this.maxWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
            }
        }

        window.addEventListener('resize', _.debounce(calculateMaxWidth, 100))
        calculateMaxWidth()
    }
    // created() {
    //     this.$parent.$on('lazyImageLoad', (slide, image) => {
    //         console.log('lazyImageLoad', slide, image);
    //     })
    //     this.$parent.$on('lazyImageReady', (slide, image) => {
    //         console.log('lazyImageReady', slide, image);
    //     })
    // }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    .slide
        & > section
            &.right
                & > .content
                    padding: 30px
                    padding-bottom: 60px
                    .more-link
                        font-weight: 600
                        font-size: 1.1rem
                        margin-top: 15px
                        display: block
            &.left
                & > .image
                    padding: 30px
                    text-align: center
                    figure
                        display: inline-block
                        transition: transform .8s ease
                        position: relative
                        img
                            // max-height: 140px
                            width: auto
                            border-radius: 4px
                            transition: box-shadow .8s ease
                            // &.preview
                            //     transition: box-shadow .8s ease, opacitiy 3s ease
                            &[lazy=loading]
                                // height: 140px
                                box-shadow: none
                            &[lazy=loaded]
                                // box-shadow: $box-shadow-2
                                box-shadow: $box-shadow-3
                            &.swiper-lazy
                                display: none
                                &.swiper-lazy-loaded
                                    display: block
                                    & + img.preview
                                        // position: absolute
                                        // top: 0
                                        // left: 0
                                        // opacity: 0
                                        display: none
    +desktop
        .slide
            display: flex
            & > section
                flex-grow: 1
                flex-shrink: 0
                flex-basis: 50%
                &.right
                    min-height: 400px
                    display: flex
                    justify-content: center
                    flex-direction: column
                    & > .content
                        padding: 30px 80px 30px
                &.left
                    display: flex
                    & > .image
                        padding-left: 60px
                        display: flex
                        flex-direction: column
                        justify-content: center
                        align-items: center
                        flex-grow: 1
                        figure
                            img
                                // max-height: 400px
                                &[lazy=loading]
                                    // height: 400px
            &.hover
                & > section.left > .image figure
                    transform: scale(1.04)
                    img
                        box-shadow: $box-shadow-4
</style>
